<template>
    <div class="search-controls">
        <div class="search-row">
            <select v-model="filter.searchType" class="search-type">
                <option value="all">전체</option>
                <option :value="option.value" v-for="option in options" :key="option.value">{{option.label}}</option>
            </select>
            <input v-model="filter.searchText" placeholder="검색어 입력" class="search-input" @keyup.enter="fetchExamResults" maxlength="100"/>
            <VueDatePicker
                v-model             = "filter.startDate"
                placeholder         = "검색 시작일"
                input-class         = "datepicker-input"
                :enable-time-picker = "false"
                format              = "yyyy-MM-dd"
                :model-type         = "'format'"
            />
            <span>~</span>
            <VueDatePicker
                v-model             = "filter.endDate"
                placeholder         = "검색 종료일"
                input-class         = "datepicker-input"
                :enable-time-picker = "false"
                format              = "yyyy-MM-dd"
                :model-type         = "'format'"
            />
        </div>
        <div class="search-button-row">
            <button @click="fetchExamResults" class="search-btn">검색</button>
            <button @click="resetSearch()" class="reset-btn" >초기화</button>
        </div>
        <!-- <button @click="fetchExamResults" class="search-btn">검색</button>
        <button @click="resetSearch()" class="reset-btn" >초기화</button> -->
    </div>
</template>
<script setup>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';

    const props = defineProps({
        filter: {
            type: Object,
            required: true,
        },
        options: {
            type: Array,
            required: true
        }
    });

    const today = new Date();
    if (!props.filter.startDate) props.filter.startDate = null;
    if (!props.filter.endDate) props.filter.endDate = null;


    const emit = defineEmits(['search'])

    const fetchExamResults = () => {
        emit('search', 1)
    }
    const resetSearch = () => {
        emit("reset");
    };
</script>

<style scoped>
    /* :deep(.dp__main) {
        width: 150px;
    }
    :deep(.dp__input) {
        height: 54px;
    } */

    /* VueDatePicker (시작일 / 종료일) */
    :deep(.dp__main) {
    flex: 2.5 1 0;
    min-width: 0;
    width: auto !important;
    }

    /* 높이 유지 */
    :deep(.dp__input) {
    height: 54px;
    }

    /* ~ 기호는 폭 고정 */
    .search-row > span {
    flex: 0 0 auto;
    }
    /* @vuepic/vue-datepicker 팝업(캘린더) z-index 올리기 */
    .dp__menu {
        z-index: 99999 !important;
    }

</style>